import { render } from "./PurchaseView.vue?vue&type=template&id=516069b8"
import script from "./PurchaseView.vue?vue&type=script&lang=js"
export * from "./PurchaseView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__